<template>
  <div class="full-container">
    <div
        style="width: 100%;float: left;height: 50px;line-height: 50px;font-size: 0.9rem; text-align: left;opacity: 0.9;">
      流程服务自定义>类型
    </div>
    <div style="width:100%;height:auto;float:left;border-radius: 15px;background-color: white;padding-bottom:40px;">
      <div style="width:100%;float:left;margin-top: 10px;">
        <!-- 查询按钮区 -->
        <div style="width: 100%;height: 60px;float: left;line-height: 60px;padding-left: 15px">
          <div style="width: auto;float: left;margin-right: 20px">
            <label style="float: left;font-size: 0.9rem;opacity: 0.9;">类型名称：</label>
            <el-input v-model="selectForm.name" clearable placeholder="模糊查询" prefix-icon="el-icon-search"
                      size="mini" style="width: 200px;float: left;"></el-input>
          </div>
          <div style="width: auto;float: left;margin-right: 20px">
            <el-button size="mini" style="background-color: #25AD7F;border:none;" type="primary"
                       @click="pageAllWorkflowType(true)">搜索
            </el-button>
            <el-button size="mini" style="background-color: #25AD7F1A;border:1px solid #25AD7F;color:#25AD7F"
                       type="primary" @click="selectReset()">重置
            </el-button>
          </div>
          <!-- 右边按钮 -->
          <div style="width: auto;float: right;margin-right: 20px">

            <el-button size="mini" style="background-color: #25AD7F1A;border:1px solid #25AD7F;color:#25AD7F"
                       type="primary" @click="insertShow">
              <a-icon type="plus-circle"/>
              新增
            </el-button>

            <el-button size="mini" style="background-color: #25AD7F1A;border:1px solid #25AD7F;color:#25AD7F"
                       type="primary" @click="exportTable">
              <a-icon type="plus-circle"/>
              批量导出
            </el-button>

            <a-popconfirm cancel-text="取消" ok-text="确定" title="是否删除?(敏感操作!)"
                          @confirm="deleteWorkflowTypeBatch()">
              <el-button size="mini" style="background-color: #e32e2e1a;color:#e32e2e;border:1px solid #e32e2e;"
                         type="primary">
                <a-icon type="minus-circle"/>
                批量删除
              </el-button>
            </a-popconfirm>
          </div>
        </div>
        <!-- 表单内容 -->
        <div style="width:100%;float:left;padding: 15px;">
          <el-table v-loading="tableLoading" :data="tableData" align="center" height="600"
                    size="mini" style="color: #555;" @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column align="center" label="类型名称" min-width="20%" prop="name"></el-table-column>
            <el-table-column align="center" label="流程节点" min-width="20%">

              <template slot-scope="scope">
                <span style="color: green;font-weight: 600">
                  {{ scope.row.workflowTypeListVOList ? scope.row.workflowTypeListVOList.length : 0 }}
                </span>

                <span style="font-size:0.9rem;color:#25AD7F;cursor: pointer;margin-left: 16px"
                      @click="workflowTypeConfigShow(scope.row)">配置</span>
              </template>

            </el-table-column>
            <el-table-column align="center" label="创建时间" min-width="20%" prop="createDateStr"></el-table-column>
            <el-table-column align="center" label="操作" min-width="20%">
              <template slot-scope="scope">
                <span style="font-size:0.9rem;color:#25AD7F;cursor: pointer;"
                      @click="infoShow(scope.row)">详情</span>
                <span style="margin:0px 5px">|</span>
                <span style="font-size:0.9rem;cursor: pointer;color: #409EFF"
                      @click="updateShow(scope.row)">修改</span>
                <a-popconfirm cancel-text="取消" ok-text="确定" title="是否删除?(敏感操作!)"
                              @confirm="deleteWorkflowType(scope.row)">
                  <span style="margin:0px 5px">|</span>
                  <span style="font-size:0.9rem;color:#e32e2e;cursor: pointer;">删除</span>
                </a-popconfirm>
              </template>
            </el-table-column>
          </el-table>
          <div style="width: 100%;float: right;margin-top: 10px;text-align: right;">
            <el-pagination
                :current-page="selectForm.pageIndex"
                :page-size="selectForm.pageSize"
                :total="selectForm.total"
                layout="total,prev, pager, next"
                @current-change="handleCurrentChange">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>


    <el-dialog :before-close="insertCancel" :visible.sync="insertDialog" title="新增类型" width="40%">
      <div style="width: 100%;float: left">
        <el-form label-width="15%" style="width:100%;float:left;">

          <el-form-item style="">
            <template slot="label">
              类型名称 <span style="color: red">*</span>
            </template>
            <el-input v-model="insertForm.name" oninput="if(value.length>35)value=value.slice(0,35)" size="mini"
                      style="width:85%;float: left;"/>
            <div style="width: 15%;float: left;text-indent: 5px;"></div>
          </el-form-item>
        </el-form>

      </div>
      <div class="dialog-footer">
        <el-button class="dialog-footer-submit" @click="insertSubmit">提交</el-button>
        <el-button class="dialog-footer-cancel" @click="insertCancel">取消</el-button>
      </div>
    </el-dialog>

    <!-- 详情 -->
    <el-dialog :before-close="infoCancel" :visible.sync="infoDialog" title="类型详情" width="40%">
      <div style="width: 100%;float: left">
        <div
            v-if="infoData"
            style="width: 100%;float: left;border-bottom: 1px solid #80808054;padding-bottom: 15px;margin-bottom: 20px;">
          <el-descriptions :column=2 :title="infoData.name?infoData.name:''">
            <el-descriptions-item label="类型名称">{{ infoData.name ? infoData.name : "" }}
            </el-descriptions-item>
            <el-descriptions-item :span="2" label="创建时间">
              {{ infoData.createDateStr }}
            </el-descriptions-item>
          </el-descriptions>
        </div>

      </div>
      <div class="dialog-footer">
        <el-button class="dialog-footer-cancel" @click="infoCancel">关闭</el-button>
      </div>
    </el-dialog>

    <!-- 修改 -->
    <el-dialog :before-close="updateCancel" :visible.sync="updateDialog" title="修改类型" width="40%">
      <div style="width: 100%;float: left">
        <el-form label-width="15%" style="width:100%;float:left;">
          <el-form-item style="">
            <template slot="label">
              类型名称 <span style="color: red">*</span>
            </template>
            <el-input v-model="updateForm.name" oninput="if(value.length>35)value=value.slice(0,35)" size="mini"
                      style="width:85%;float: left;"/>
            <div style="width: 15%;float: left;text-indent: 5px;"></div>
          </el-form-item>
        </el-form>
      </div>
      <div class="dialog-footer">
        <el-button class="dialog-footer-submit" @click="updateSubmit">提交</el-button>
        <el-button class="dialog-footer-cancel" @click="updateCancel">取消</el-button>
      </div>
    </el-dialog>


    <el-dialog :before-close="insertCancel" :visible.sync="insertDialog" title="新增类型" width="40%">
      <div style="width: 100%;float: left">
        <el-form label-width="15%" style="width:100%;float:left;">

          <el-form-item style="">
            <template slot="label">
              类型名称 <span style="color: red">*</span>
            </template>
            <el-input v-model="insertForm.name" oninput="if(value.length>35)value=value.slice(0,35)" size="mini"
                      style="width:85%;float: left;"/>
            <div style="width: 15%;float: left;text-indent: 5px;"></div>
          </el-form-item>
        </el-form>

      </div>
      <div class="dialog-footer">
        <el-button class="dialog-footer-submit" @click="insertSubmit">提交</el-button>
        <el-button class="dialog-footer-cancel" @click="insertCancel">取消</el-button>
      </div>
    </el-dialog>

    <!-- 配置流程节点 -->
    <el-dialog :before-close="workflowTypeConfigCancel"
               :title="'配置流程节点：'+(workflowTypeConfig?workflowTypeConfig.name:'')" :visible.sync="workflowConfigDialog" width="40%">
      <div style="width: 100%;float: left">
        <el-form v-if="workflowTypeConfig" label-width="15%" style="width:100%;float:left;">
          <div v-for="(workflowTypeList,index) in updateWorkflowTypeListVOList"
               style="border-bottom: 1px solid gray;margin-bottom: 16px">
            <div style="width: 100%;text-align: left;font-weight: 600;font-size: 1.2rem;padding-left: 5%;color: green;">
              节点{{ index + 1 }}
              <el-button icon="el-icon-delete" size="mini" style="margin-left:16px" type="danger"
                         @click="deleteWorkflowTypeList(index)"></el-button>

            </div>

            <el-form-item style="">
              <template slot="label">
                职务名称 <span style="color: red">*</span>
              </template>
              <el-input v-model="workflowTypeList.ministry" oninput="if(value.length>35)value=value.slice(0,35)" placeholder="工作人员"
                        size="mini"
                        style="width:85%;float: left;"/>
              <div style="width: 15%;float: left;text-indent: 5px;"></div>
            </el-form-item>

            <el-form-item v-for="(workflowTypeItem,num) in workflowTypeList.workflowTypeItemVOList" style="">
              <template slot="label">
                工作 <span style="color: red">*</span>
              </template>
              <el-input v-model="workflowTypeItem.item" oninput="if(value.length>35)value=value.slice(0,35)" placeholder="工作内容"
                        size="mini"
                        style="width:85%;float: left;"/>
              <div style="width: 15%;float: left;text-indent: 5px;">
                <i class="el-icon-remove-outline" style="color: red"
                   @click="deleteWorkflowTypeItem(num,workflowTypeList.workflowTypeItemVOList,index)"></i>
              </div>
            </el-form-item>

            <el-form-item style="">
              <template slot="label">
                添加工作内容
              </template>
              <i class="el-icon-circle-plus-outline"
                 style="color: green" @click="insertWorkflowTypeItem(workflowTypeList.id,workflowTypeList.workflowTypeItemVOList)"></i>
              <div style="width: 15%;float: left;text-indent: 5px;"></div>
            </el-form-item>

            <el-form-item style="">
              <template slot="label">
                是否必须 <span style="color: red">*</span>
              </template>
              <el-switch v-model="workflowTypeList.isNeed" active-color="#13ce66" active-value="1" inactive-color="#ff4949"
                         inactive-value="0"></el-switch>
              <div style="width: 15%;float: left;text-indent: 5px;"></div>
            </el-form-item>


          </div>
        </el-form>
      </div>
      <div style="width: 100%;float: left;text-align: left">
        <el-button size="mini" type="primary" @click="insertWorkflowTypeList">添加节点</el-button>
      </div>
      <div class="dialog-footer" style="margin-top: 16px;">
        <el-button class="dialog-footer-submit" @click="workflowTypeConfigSubmit">保存</el-button>
        <el-button class="dialog-footer-cancel" @click="workflowTypeConfigCancel">取消</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>

import * as XLSX from "xlsx";
import {
  deleteWorkflowTypeApi,
  insertWorkflowTypeApi,
  pageAllWorkflowTypeApi,
  updateWorkflowTypeApi,
  workflowTypeConfigApi
} from "@/router/api/workflow/workflow-type-api";

export default {
  name: "WorkflowTypeIndex",
  data() {
    return {

      //查询
      tableData: [],
      selectForm: {
        name: null,
        pageIndex: 1,
        pageSize: 10,
        total: 0
      },
      selectTableRow: [],
      tableLoading: false,


      // 新增
      insertDialog: false,
      insertForm: {
        name: null
      },

      //  详情
      infoDialog: false,
      infoData: {},

      //修改
      updateDialog: false,
      updateForm: {
        id: null,

        name: null,

      },


      //流程节点：
      workflowConfigDialog: false,
      workflowTypeConfig: null,
      updateWorkflowTypeListVOList: [],
    }

  },

  mounted() {
    this.pageAllWorkflowType();
  },

  methods: {

    //流程配置  begin
    workflowTypeConfigShow(workflowType) {
      this.workflowTypeConfig = workflowType;
      this.updateWorkflowTypeListVOList = this.workflowTypeConfig.workflowTypeListVOList;
      this.workflowConfigDialog = true;
    },

    workflowTypeConfigCancel() {
      this.workflowConfigDialog = false;
      this.workflowTypeConfig = null;
      this.updateWorkflowTypeListVOList = [];
      this.pageAllWorkflowType();
    },

    workflowTypeConfigSubmit() {
      this.workflowTypeConfig.workflowTypeListVOList = this.updateWorkflowTypeListVOList;
      this.workflowTypeConfig.createDate = null;
      workflowTypeConfigApi(this.workflowTypeConfig, res => {
        //状态200
        if (res.status == "200") {
          if (res.data && res.data.status && res.data.msg) {
            if ("1" == res.data.status) {
              this.showMessage(res.data.msg, "success");
              this.workflowTypeConfigCancel()
              this.pageAllWorkflowType();
            } else {
              this.showMessage(res.data.msg, "error");
            }
          } else {
            this.showMessage("未知请求出错", "error");
          }
        } else {
          this.showMessage("未知请求出错！", "error");
        }
      });
    },

    // 删除节点
    deleteWorkflowTypeList(index) {
      let tempList = [];
      for (let i = 0; i < this.updateWorkflowTypeListVOList.length; i++) {
        if (index != i) {
          tempList.push(this.updateWorkflowTypeListVOList[i]);
        }
      }
      this.updateWorkflowTypeListVOList = tempList;

    },

    // 添加节点
    insertWorkflowTypeList() {
      this.updateWorkflowTypeListVOList.push({
        workflowTypeId: this.workflowTypeConfig.id,
        ministry: null,
        isNeed: "1",
        workflowTypeItemVOList: []
      })
    },

    // 添加工作
    insertWorkflowTypeItem(workflowTypeListId, workflowTypeItemVOList) {
      workflowTypeItemVOList.push({
        // workflowTypeListId:workflowTypeListId,
        item: null
      });
    },
    // 删除工作
    deleteWorkflowTypeItem(num, workflowTypeItemVOList, index) {
      let tempList = [];
      for (let i = 0; i < workflowTypeItemVOList.length; i++) {
        if (num != i) {
          tempList.push(workflowTypeItemVOList[i]);
        }
      }
      this.updateWorkflowTypeListVOList[index].workflowTypeItemVOList = tempList;
    },

    //流程配置  end


    // 新增 begin
    insertShow() {
      this.insertDialog = true;
    },

    insertCancel() {
      this.insertDialog = false;
      this.insertForm = {
        name: null,
      }
    },

    insertSubmit() {

      if (!this.insertForm.name) {
        this.showMessage("请填写类型名称", "error");
        return false;
      }

      insertWorkflowTypeApi(this.insertForm, res => {
        //状态200
        if (res.status == "200") {
          if (res.data && res.data.status && res.data.msg) {
            if ("1" == res.data.status) {
              this.showMessage(res.data.msg, "success");
              this.insertCancel()
              this.pageAllWorkflowType();
            } else {
              this.showMessage(res.data.msg, "error");
            }
          } else {
            this.showMessage("未知请求出错", "error");
          }
        } else {
          this.showMessage("未知请求出错！", "error");
        }
      });
    },

    // 新增 end

    // 查询 begin
    selectReset() {
      this.selectForm = {
        merchantNo: null,
        companyName: null,
        pageIndex: 1,
        pageSize: 10,
        total: 0
      }
      this.pageAllWorkflowType(true);
    },

    handleCurrentChange(e) {
      this.selectForm.pageIndex = e;
      this.pageAllWorkflowType(true);
    },

    handleSelectionChange(val) {
      this.selectTableRow = val;
    },

    pageAllWorkflowType(showMessage) {
      this.tableLoading = true;
      pageAllWorkflowTypeApi(this.selectForm, res => {
        if (res.status == "200") {
          if (res.data && res.data.status && res.data.msg) {
            if ("1" == res.data.status) {
              if (showMessage) {
                this.showMessage(res.data.msg, "success");
              }
              this.tableData = res.data.resultSetData.list;
              this.selectForm.pageIndex = res.data.resultSetData.pageNum;
              this.selectForm.pageSize = res.data.resultSetData.pageSize;
              this.selectForm.total = res.data.resultSetData.total;
            } else {
              this.showMessage(res.data.msg, "error");
            }
          } else {
            this.showMessage("未知请求出错", "error");
          }
        } else {
          this.showMessage("未知请求出错！", "error");
        }
      }, res => {
        this.tableLoading = false;
      });
    },

    exportTable() {
      if (!this.selectTableRow || this.selectTableRow.length == 0) {
        this.showMessage("请勾选需要导出的数据", "warning");
        return false;
      }

      const data = [
        ["类型名称", "节点数量","创建时间"]
      ];

      //添加数据
      for (let i = 0; i < this.selectTableRow.length; i++) {
        let row = this.selectTableRow[i];
        if (row) {
          let cell1 = row.name;
          let cell2 = row.workflowTypeListVOList ? row.workflowTypeListVOList.length : 0;
          let cell3 = row.createDateStr ? row.createDateStr : "";
          data.push([cell1, cell2, cell3]);
        }
      }
      // 将数据转换为工作表
      const worksheet = XLSX.utils.aoa_to_sheet(data);

      // 创建工作簿并添加工作表
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

      // 生成Excel文件
      const excelBuffer = XLSX.write(workbook, {bookType: "xlsx", type: "array"});

      // 使用blob和FileReader创建一个Blob URL
      const dataBlob = new Blob([excelBuffer], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8"});
      const blobUrl = window.URL.createObjectURL(dataBlob);

      // 使用saveAs下载文件
      saveAs(dataBlob, "流程服务类型-" + new Date().toLocaleString() + ".xlsx");

      // 清理
      window.URL.revokeObjectURL(blobUrl);
    },
    // 查询 end


    // update begin
    updateShow(data) {
      this.updateDialog = true;
      this.updateForm = {
        id: data.id,
        name: data.name,
      };
    },
    updateCancel() {
      this.updateDialog = false;
      this.updateForm = {
        id: null,
        name: null,
      };
    },

    updateSubmit() {
      //TODO 非空判断
      if (!this.updateForm.name) {
        this.showMessage("请填写类型名称", "error");
        return false;
      }

      updateWorkflowTypeApi(this.updateForm, res => {
        //状态200
        if (res.status == "200") {
          if (res.data && res.data.status && res.data.msg) {
            if ("1" == res.data.status) {
              this.showMessage(res.data.msg, "success");
              this.updateCancel();
              this.pageAllWorkflowType();
            } else {
              this.showMessage(res.data.msg, "error");
            }
          } else {
            this.showMessage("未知请求出错", "error");
          }
        } else {
          this.showMessage("未知请求出错！", "error");
        }
      });
    },

    // 删除 begin
    deleteWorkflowType(item) {
      if (!item) {
        this.showMessage("请选择需要删除的农作物", "warning");
        return false;
      }
      let params = [
        {
          "id": item.id
        }
      ];
      deleteWorkflowTypeApi(params, res => {
        //状态200
        if (res.status == "200") {
          if (res.data && res.data.status && res.data.msg) {
            if ("1" == res.data.status) {
              this.showMessage(res.data.msg, "success");
              this.pageAllWorkflowType();
            } else {
              this.showMessage(res.data.msg, "error");
            }
          } else {
            this.showMessage("未知请求出错", "error");
          }
        } else {
          this.showMessage("未知请求出错！", "error");
        }
      });
    },

    deleteWorkflowTypeBatch() {
      if (!this.selectTableRow || this.selectTableRow.length == 0) {
        this.showMessage("请勾选需要需要删除的类型", "warning");
        return false;
      }

      let params = [];
      for (let i = 0; i < this.selectTableRow.length; i++) {
        let row = this.selectTableRow[i];
        if (row) {
          params.push({
            "id": row.id
          });
        }
      }

      deleteWorkflowTypeApi(params, res => {
        //状态200
        if (res.status == "200") {
          if (res.data && res.data.status && res.data.msg) {
            if ("1" == res.data.status) {
              this.showMessage(res.data.msg, "success");
              this.pageAllWorkflowType();
            } else {
              this.showMessage(res.data.msg, "error");
            }
          } else {
            this.showMessage("未知请求出错", "error");
          }
        } else {
          this.showMessage("未知请求出错！", "error");
        }
      });
    },

    // 删除 end

    // update end
    infoShow(data) {
      this.infoDialog = true;
      this.infoData = data;
    },

    infoCancel() {
      this.infoDialog = false;
      this.infoData = {};
    },

    // 工具
    parseDate(date) {
      if (date) {
        return new Date(date).toLocaleString();
      }
      return "";
    }
  }

};

</script>


<style scoped>

.dialog-footer {
  width: 100%;
  float: left;
  text-align: left;
}

.dialog-footer-submit {
  background-color: #25AD7F;
  color: white;
  width: 130px;
  border-radius: 50px;
  letter-spacing: 3px;
  text-align: center;
  font-weight: 100;
}

.dialog-footer-submit:hover {
  background-color: #25AD7F;
  color: white;
  width: 130px;
  border-radius: 50px;
  letter-spacing: 3px;
  text-align: center;
  font-weight: 100;
}

.dialog-footer-cancel {
  background-color: white;
  border: 1px solid #8080805c;
  color: #8080805c;
  width: 130px;
  border-radius: 50px;
  letter-spacing: 3px;
  text-align: center;
  font-weight: 100;
}

.dialog-footer-cancel:hover {
  background-color: white;
  border: 1px solid #8080805c;
  color: #8080805c;
  width: 130px;
  border-radius: 50px;
  letter-spacing: 3px;
  text-align: center;
  font-weight: 100;
}

/* 树形菜单 */

/deep/ .el-tree-node__content {
  height: 35px;
  line-height: 35px;
}

/* 表格 */

/deep/ .el-table th.el-table__cell {
  background-color: #F8F8F8;
}

/deep/ .el-table th.el-table__cell > .cell {
  color: #554 !important;
  font-weight: 600;
  font-size: 1.05rem;
}

/* 模态框 */

/deep/ .el-dialog__title {
  font-weight: 600;
}

/deep/ .el-dialog__header {
  text-align: left;
  border-bottom: 1px solid darkgray;
}

/deep/ .el-dialog__body {
  width: 100%;
  float: left;
  background-color: white;
}

/deep/ .el-upload-dragger {
  height: auto;
}

/deep/ .el-form-item__content {
  text-align: left;
}

</style>
